import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { UserModel } from '../../models/platform/userModel';
import { AccountModel } from '../../models/platform/accountModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class AuthApi {

    async loginUser(user: UserModel) {
        try {
            const payload =
            {
                email : user.email,
                password : user.password,
            };

            const response = await axios.post(`${API_URL}/api/auth/login/`, payload,
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }
    
    async resetPassword(auth_code: string, password: string) {
        try {
            const payload =
            {
                auth_code,
                password,
            };

            const response = await axios.post(`${API_URL}/api/auth/password/reset`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

    async registerUser(user: UserModel, account: AccountModel) {
        try {
            const payload =
            {
                company_name : account.company_name,
                company_size: account.company_size,
                email: user.email,
                first_name: user.first_name,
                last_name : user.last_name,
                phone_number: user.phone_number,
                title : user.title,
            };

            const response = await axios.post(`${API_URL}/api/auth/register/`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

    async requestResetPassword(email: string) {
        try {
            const payload =
            {
                email,
            };

            const response = await axios.post(`${API_URL}/api/auth/password/request-reset`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }
    
    async updateEmail(auth_code: string) {
        try {
            const payload =
            {
                auth_code,
            };

            const response = await axios.put(`${API_URL}/api/auth/email/update`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

}

const authApi = new AuthApi();
export default authApi;
